<template>
  <div class="row">
    <div
      class="col-md-6 col-sm-6 col-lg-6 col-xl-3"
      v-for="(row,index) in balancesData"
      :key="index"
    >
      <div class="card dash-widget">
        <div class="card-body">
          <span class="dash-widget-icon">
            <i class="fa fa-cubes"></i>
          </span>
          <div class="dash-widget-info">
            <h3>{{row.total}}</h3>
            <span>{{row.asset}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div>{{balancesData}}</div>
  {{getAsset("SHIBUSDT")}}-->
</template>
<script>
import { Skeleton } from "vue-loading-skeleton";
import { mapGetters } from "vuex";

export default {
  components: {
    Skeleton
  },
  props: {
    markets: {
      type: Object,
      default: function() {
        return {
          id: "",
          title: ""
          // qrcode: ""
        };
      }
      // required: true
    }
  },
  data() {
    return {
      loading: false
    };
    //  isactive : true
  },
  computed: {
    ...mapGetters(["getBalanceDataByAsset"]),
    balancesData() {
      let balances = this.$store.state.binance.balancesData;
      let data = [];
      balances.forEach((row, index) => {
        var totalBalance = 0;
        totalBalance = Number(row.free) + Number(row.locked);
        if (totalBalance > 0) {
          data.push({
            asset: row.asset,
            free: row.free,
            locked: row.locked,
            total: totalBalance
          });
        }
      });
      return data;
    }
  },
  async created() {
    this.getAccount();
  },
  methods: {
    getAccount() {
      this.$store.dispatch("binance/GetAccount");
    },
    getAsset(symbol) {
      let asset = symbol.toUpperCase();
      return asset.replace(/USDT/g, "");
    }
  },
  mounted() {},
  name: "binance-balances"
};
</script>


// WEBPACK FOOTER //
// src/views/binance/balance.vue